import { Enterprise } from 'domain/enterprise';

export class Project {
  static directoryOrProposal(props) {
    const { project, projectProposal, directory, currentUser } = props;
    let options = [];
    if (Enterprise.subcontractor(project.contributor_type)) {
      options =
        directory &&
        directory.project_contributors.filter((contrib) => {
          return (
            contrib.company_id === currentUser.accountable_id &&
            contrib.company_type === currentUser.accountable_type
          );
        });
    } else {
      options = projectProposal && projectProposal.project_proposal_items;
      options && directory && options.push(...directory.project_contributors);
    }

    return options || [];
  }

  static csiCodesOptions(props) {
    let csiCodeIds = {};
    return this.directoryOrProposal(props)
      .filter((item) => !!item.csi_code)
      .map((item) => {
        const { csi_code } = item;
        if (csiCodeIds[csi_code.id]) {
          return null;
        } else {
          csiCodeIds[csi_code.id] = true;
          return {
            value: csi_code.id,
            label: `${csi_code.division} - ${csi_code.label}`,
          };
        }
      })
      .filter((csiCode) => !!csiCode)
      .sort((csiCode1, csiCode2) => (csiCode1.label < csiCode2.label ? -1 : 1));
  }

  static subcontractorOptions(props, csiCodeId) {
    return (
      (csiCodeId && props.directory && props.directory.project_contributors) ||
      []
    )
      .filter((item) => !!item.csi_code && item.csi_code.id === csiCodeId)
      .map((item) => {
        return {
          value: item.company_id,
          label: item.company.name,
        };
      })
      .sort((sub1, sub2) => (sub1.label < sub2.label ? -1 : 1));
  }

  static projectContributorOptions(props) {
    return ((props.directory && props.directory.project_contributors) || [])
      .filter((item) => !!item.csi_code)
      .map((item) => {
        return {
          value: item.id,
          label: `${item.csi_code.division} ${item.csi_code.label} - ${
            item.company.name || item.company.company_name
          }`,
        };
      })
      .sort((item1, item2) => (item1.label < item2.label ? -1 : 1));
  }

  static userLabelStr(user, company) {
    return `${user.first_name} ${user.last_name} - ${
      company.name || company.company_name
    }`;
  }

  static filterRecipients(props, onlyPrimary = false) {
    const { directory } = props;
    if (!directory) {
      return [];
    }

    let users = {};
    let contributors = directory.project_contributors;
    contributors = onlyPrimary
      ? contributors.filter((pc) => pc.primary)
      : contributors;
    return contributors
      .map((pc) => {
        return pc.users
          .filter((usr) => !users[usr.id])
          .map((usr) => {
            users[usr.id] = true;
            const usrLabel = this.userLabelStr(usr, pc.company);
            return { id: usr.id, label: usrLabel };
          });
      })
      .reduce((acc, val) => acc.concat(val), []);
  }

  static recipientOptions(props) {
    return this.filterRecipients(props);
  }

  static primaryRecipientOptions(props) {
    return this.filterRecipients(props, true);
  }
}



// WEBPACK FOOTER //
// ./src/domain/project.js